// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3HWlc","footer":"ChangeClinic_footer__2EfTe"};